import { IconButton } from "@/components/Atoms/IconButton";
import { useState } from "react";
import { GrSearch } from "../../../Atoms/AppIcons";
import Loader from "../../../Atoms/Loader";
import s from "../SearchBar.module.scss";
import { SearchBarProps } from "../types";
import SearchModal from "./LazySearchModal";

export default function TinySearchBar({ loading, ...props }: SearchBarProps) {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      {loading ? (
        <div
          style={{
            transform: "translateX(4px)",
          }}
        >
          <Loader size={32} thickness={4} color="#fff" />
        </div>
      ) : (
        <IconButton
          aria-label="Search"
          onClick={() => {
            setOpenModal(true);
          }}
        >
          <GrSearch className={s.SmallIcon} size={20} />
        </IconButton>
      )}
      <SearchModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        {...props}
      />
    </>
  );
}
